import type { SVGProps } from 'react';

interface CloseIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const CloseIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & CloseIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 32 32"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M10.341 8.929 23.07 21.657a1 1 0 0 1-1.326 1.492l-.088-.078L8.927 10.343a1 1 0 0 1 1.326-1.492z"
      fill="#4FA9FF"
    />
    <path
      d="M23.07 10.343 10.34 23.071a1 1 0 0 1-1.492-1.327l.078-.087L21.655 8.929a1 1 0 0 1 1.492 1.326z"
      fill="#4FA9FF"
    />
  </svg>
);
